import { Tag, Sparkles, Phone, CreditCard } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function PromoFinancing() {
  return (
    <section className="bg-[#122744] bp-grid-dark text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20 md:py-24 grid lg:grid-cols-2 gap-10 items-center">
        {/* Coupon */}
        <div
          data-testid="promo-coupon"
          className="relative bg-[#C5A572] text-[#122744] rounded-md p-8 md:p-10 overflow-hidden"
        >
          <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-[#D9BF8C]/50" />
          <div className="absolute -right-4 -bottom-10 w-32 h-32 rounded-full bg-[#D9BF8C]/50" />
          <div className="relative">
            <div className="inline-flex items-center gap-2 bg-[#122744] text-[#D9BF8C] px-3 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-widest">
              <Tag size={12} /> New Customer Special
            </div>
            <div className="font-display font-black text-7xl md:text-8xl tracking-tight mt-4 leading-none">
              $50<span className="text-3xl align-top">OFF</span>
            </div>
            <p className="font-display font-bold text-xl mt-2">
              Any service over $250
            </p>
            <p className="text-[#122744]/80 text-sm mt-2 max-w-sm">
              Mention this offer when you call or note code <span className="font-mono bg-[#122744] text-[#D9BF8C] px-1.5 py-0.5 rounded">PEAK50</span> when you book. New customers only.
            </p>
            <a
              data-testid="promo-coupon-cta"
              href={`tel:${COMPANY.phoneTel}`}
              className="mt-6 inline-flex items-center gap-2 bg-[#122744] text-white font-bold px-5 py-3 rounded-sm hover:bg-[#1E3A5F] transition"
            >
              <Phone size={16} /> Claim Discount
            </a>
          </div>
        </div>

        {/* Financing */}
        <div data-testid="promo-financing">
          <div className="flex items-baseline gap-3">
            <span className="font-display font-black text-sm text-[#D9BF8C]">05 —</span>
            <div className="label-eyebrow text-orange-400">Financing</div>
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-black tracking-tight mt-2">
            Big repair? <span className="text-orange-400">0% APR financing</span> available.
          </h2>
          <p className="text-slate-300 md:text-lg mt-4 max-w-lg">
            Don't put off urgent plumbing work over budget. We partner with leading
            providers to offer flexible 0% APR plans for qualified homeowners — get
            the job done now, pay over time.
          </p>

          <ul className="mt-6 space-y-2.5 text-slate-200">
            {[
              "0% APR for qualified customers",
              "Quick online application — answer in minutes",
              "No prepayment penalties",
              "Available on sewer, water heater & repipe jobs",
            ].map((p, i) => (
              <li key={i} className="flex items-start gap-2">
                <Sparkles size={16} className="text-orange-400 mt-1 shrink-0" />
                <span>{p}</span>
              </li>
            ))}
          </ul>

          <a
            data-testid="promo-financing-cta"
            href="#quote"
            className="btn-cta mt-7 inline-flex items-center gap-2 px-5 py-3"
          >
            <CreditCard size={16} /> Ask About Financing
          </a>
        </div>
      </div>
    </section>
  );
}
